module.exports = __webpack_public_path__ + "img/video-play.75fd7996.svg";